module.exports = __webpack_public_path__ + "img/classic_m7.fb34c256.png";